"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMultiScalpingV3Parameters = void 0;
const types_1 = require("../types");
const isMultiScalpingV3Parameters = (x) => x.method === types_1.Method.MultiScalpingV3;
exports.isMultiScalpingV3Parameters = isMultiScalpingV3Parameters;
